"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var defaultStyles = "\n  background-color: ".concat(_tokens["default"].color.white, ";\n  border: 1px solid ").concat(_tokens["default"].border.color, ";\n  border-radius: ").concat(_tokens["default"].card.borderRadius, ";\n  box-shadow: ").concat(_tokens["default"].shadow, ";\n  color: ").concat(_tokens["default"].textColor["default"], ";\n  padding: ").concat(_tokens["default"].space, " ").concat(_tokens["default"].spaceLg, ";\n");
var darkStyles = "\n  background-color: ".concat(_tokens["default"].color.black, ";\n  border: 1px solid ").concat(_tokens["default"].color.black, ";\n  border-radius: ").concat(_tokens["default"].border.radius, ";\n  color: ").concat(_tokens["default"].color.white, ";\n  padding: ").concat(_tokens["default"].spaceSm, " ").concat(_tokens["default"].space, ";\n");

var CardStyled = _styledComponents["default"].div.withConfig({
  displayName: "Cardstyles__CardStyled",
  componentId: "sc-1penuek-0"
})(["", ";", ";", ";overflow:hidden;"], function (props) {
  return props.isDark ? darkStyles : defaultStyles;
}, _stylers["default"].fontSize(-1), _stylers["default"].lineHeight());

var _default = CardStyled;
exports["default"] = _default;
//# sourceMappingURL=Card.styles.js.map